// Smart file delivery — mobile gets a native share/preview sheet, desktop gets direct download.

export function isMobileDevice() {
  const ua = navigator.userAgent || "";
  const touchMac = ua.includes("Mac") && navigator.maxTouchPoints > 1; // iPadOS
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || touchMac;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function previewBlob(blob) {
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function canShareFile(blob, filename, mime) {
  try {
    const file = new File([blob], filename, { type: mime });
    return !!(navigator.canShare && navigator.canShare({ files: [file] }));
  } catch {
    return false;
  }
}

export async function shareFile(blob, filename, mime) {
  const file = new File([blob], filename, { type: mime });
  try {
    await navigator.share({ files: [file], title: filename });
    return true;
  } catch (e) {
    if (e?.name === "AbortError") return false;
    throw e;
  }
}

export function formatFileSize(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
